<template>
  <el-dialog
    :visible="true"
    width="90%"
    :show-close="false"
    :close-on-click-modal="false"
    class="detail-page"
    @close="shutDown"
  >
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        width="50px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="tradingDate"
        label="成交日期"
      />
      <af-table-column
        fixed
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="areaName"
        label="区域"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="totalAmount"
        label="总成交量"
      />
      <af-table-column
        prop="signBuySumAmount"
        label="采购订立量"
      />
      <af-table-column
        prop="signBuyAvgPrice"
        label="采购订立均价"
      />
      <af-table-column
        prop="transferBuySumAmount"
        label="变更采购量"
      />
      <af-table-column
        prop="transferBuyAvgPrice"
        label="变更采购均价"
      />
      <af-table-column
        prop="signSellSumAmount"
        label="销售订立量"
      />
      <af-table-column
        prop="signSellAvgPrice"
        label="销售订立均价"
      />
      <af-table-column
        prop="transferSellSumAmount"
        label="变更销售量"
      />
      <af-table-column
        prop="transferSellAvgPrice"
        label="变更销售均价"
      />
      <af-table-column
        prop="presentChangeWarehouse"
        label="变今仓量"
      />
      <af-table-column
        prop="unPresentChangeWarehouse"
        label="非变今仓量"
      />
      <af-table-column
        prop="tradeCompanyCode"
        label="贸易公司名称"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
    <div class="detailPage-btns">
      <el-button
        type="primary"
        @click="toDownload"
      >
        导出
      </el-button>
      <el-button @click="shutDown">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import api from '@/api'

export default {
  name: 'Detail',
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 10,

      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        areaId: this.row.areaId, // 区域ID
        goodsCode: this.row.goodsCode, // 购销计划代码
        tradeCompanyCode: this.row.tradeCompanyCode, // 公司名称
        tradingDate: this.row.tradingDate, // 交易日期
        marketId: this.row.marketId, // 市场id
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      let res = await api.spotPurchaseSaleInquiry.ArbitrageTransactionDetail(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
    },
    // 关闭弹窗
    shutDown () {
      this.$emit('shutDown')
    },
    // 导出
    toDownload () {
      let param = {
        areaId: this.row.areaId, // 区域ID
        goodsCode: this.row.goodsCode, // 购销计划代码
        tradeCompanyCode: this.row.tradeCompanyCode, // 公司名称
        tradingDate: this.row.tradingDate, // 交易日期
        marketId: this.row.marketId, // 市场id
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        exportType: 'TlMatchDetail',
      }
      this.$utils.getExcelFile(this, api.detail, param)
    },
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
